import { useSelector } from "react-redux";
import { IoCallOutline } from "react-icons/io5";

const NavbarNotificationBell = () => {
  const phoneNumber = useSelector(
    (state: any) => state.shopInfo.shopInfoData.phoneNumber
  );

  return (
    <a
      href={`tel:${phoneNumber}`}
      className="inline-flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-white text-slate-600 shadow-sm border border-slate-100 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-emerald-200 transition"
    >
      <span className="sr-only">Call us</span>
      <IoCallOutline className="w-5 h-5" />
    </a>
  );
};

export default NavbarNotificationBell;
